import { browserProvider } from '@peloton/newrelic';
import { commitSHA } from '@members/env';

browserProvider.getAddRelease()('members', commitSHA!);
browserProvider.getSetCustomAttribute()('commit', commitSHA!);
